import { colors } from '../../colors';
var accordion = {
  bodyBackgroundColor: colors.white,
  iconColor: colors.dirtyBlue,
  rowBackgroundColor: colors.overcast,
  textColorDark: colors.black,
  textColorLight: colors.white
};
export default accordion;